export default {
  eyebrow: 'Portail partenaire',
  title: 'Calculateur de frais de service',
  description: 'Estimez le revenu des frais de service généré par les restaurants de votre compte partenaire.',
  toasts: {
    load_error: 'Impossible de charger vos paramètres de frais de service.',
  },
};
